import React, { useEffect, useState } from 'react';
import { getCoreRowModel, Table, useBriefsTable } from '@fiverr-private/briefs_table';
import { ErrorState } from '@fiverr-private/dynamic_matching';
import { Stack } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { BriefEditSuccessModal, useBriefEditSuccessModal } from '@fiverr-private/dm_brief_creation';
import { usePaginatedBriefsList } from '../../hooks/usePaginatedBriefsList';
import { AppI18n } from '../../i18n';
import { BRIEFS_LIST_PAGE_SIZE } from '../../../../configuration/constants';
import { useColumns } from './useColumns';
import { TableNoResultsState } from './NoResultsState';
import { NoBriefsState } from './NoBriefsState';

export const BriefsTable = () => {
  const { briefsList, isError, fetchNextPage, hasNextPage, totalCount } = usePaginatedBriefsList();
  const {
    isOpen: isSuccessModalOpen,
    openModal: openSuccessModal,
    closeModal: closeSuccessModal,
  } = useBriefEditSuccessModal();
  const columns = useColumns(openSuccessModal);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: BRIEFS_LIST_PAGE_SIZE,
  });

  useEffect(() => {
    if (!pagination.pageIndex) return;
    fetchNextPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.pageIndex]);

  const table = useBriefsTable({
    data: briefsList,
    columns,
    state: { pagination },
    manualPagination: true,
    pageCount: -1,
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
  });

  if (!briefsList || isError) {
    return <ErrorState />;
  }

  return (
    <>
      <Table totalCount={totalCount} emptyPage={NoBriefsState} noResults={TableNoResultsState} table={table} />
      {hasNextPage && (
        <Stack justifyContent="center" textAlign="center">
          <Button variant="outline" className="" onClick={() => table.nextPage()}>
            <AppI18n k="table.show_more" />
          </Button>
        </Stack>
      )}
      <BriefEditSuccessModal isOpen={isSuccessModalOpen} onClose={closeSuccessModal} />
    </>
  );
};
